module.exports = __webpack_public_path__ + "static/fipcsafarimain-7bcc931cc101ca91fa67be755158b6d8.jpeg";